import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip,  } from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload?.length) {
    const d = payload?.[0]?.payload;
    return (
      <div
        className="rounded-lg border p-3 text-xs"
        style={{ background: "var(--color-card)", borderColor: "var(--color-border)", boxShadow: "var(--shadow-lg)" }}
      >
        <p className="font-heading font-semibold mb-1" style={{ color: d?.color }}>{d?.name}</p>
        <p className="font-caption" style={{ color: "var(--color-text-secondary)" }}>
          Share: <span className="font-data font-medium" style={{ color: "var(--color-foreground)" }}>{d?.value}%</span>
        </p>
        <p className="font-caption" style={{ color: "var(--color-text-secondary)" }}>
          Customers: <span className="font-data font-medium" style={{ color: "var(--color-foreground)" }}>{d?.customers?.toLocaleString()}</span>
        </p>
      </div>
    );
  }
  return null;
};

const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  if (percent < 0.06) return null;
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central" fontSize={11} fontWeight={600}>
      {`${(percent * 100)?.toFixed(0)}%`}
    </text>
  );
};

export default function AcquisitionChannels({ channels: channelsProp }) {
  const channelData = channelsProp || [];

  return (
    <div
      className="rounded-xl border"
      style={{
        background: "var(--color-card)",
        borderColor: "var(--color-border)",
        boxShadow: "var(--shadow-md)",
        padding: "20px",
      }}
    >
      <div className="mb-3">
        <h3 className="font-heading font-semibold text-base" style={{ color: "var(--color-foreground)" }}>
          Acquisition Channel Mix
        </h3>
        <p className="font-caption text-xs mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
          Customer distribution by acquisition source
        </p>
      </div>
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <div className="w-full sm:w-48 h-48 flex-shrink-0" aria-label="Acquisition channel pie chart">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={channelData}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={80}
                dataKey="value"
                labelLine={false}
                label={renderCustomLabel}
              >
                {channelData?.map((c, i) => (
                  <Cell key={i} fill={c?.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="flex-1 min-w-0 w-full">
          {channelData?.map((c) => (
            <div key={c?.name} className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2 min-w-0">
                <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: c?.color }} />
                <span className="font-caption text-xs truncate" style={{ color: "var(--color-foreground)" }}>
                  {c?.name}
                </span>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0 ml-2">
                <div className="w-20 h-1.5 rounded-full" style={{ background: "var(--color-muted)" }}>
                  <div className="h-full rounded-full" style={{ width: `${c?.value}%`, background: c?.color }} />
                </div>
                <span className="font-data text-xs font-medium w-8 text-right" style={{ color: "var(--color-foreground)" }}>
                  {c?.value}%
                </span>
                <span className="font-data text-xs w-12 text-right" style={{ color: "var(--color-text-secondary)" }}>
                  {c?.customers?.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}